export default __webpack_public_path__ + "static/media/bridge.e5d1ca12.svg";